// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpgradePrompt_upgradePrompt__Bkalh {
  border: 2px dashed #e0e0e0;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  text-align: center;
  margin: 20px 0;
}
.UpgradePrompt_upgradePrompt__Bkalh:hover {
  border-color: #007bff;
  transform: translateY(-2px);
  transition: all 0.3s ease;
}

.UpgradePrompt_upgradePromptBody__H4c3i {
  padding: 2rem;
}

.UpgradePrompt_upgradePromptIcon__PoijY {
  font-size: 3rem;
  color: #6c757d;
  margin-bottom: 1rem;
}

.UpgradePrompt_upgradePromptTitle__TUe\\+n {
  color: #495057;
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.UpgradePrompt_upgradePromptDescription__2flIO {
  color: #6c757d;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
}

.UpgradePrompt_upgradePromptButton__ikB7t {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
}
.UpgradePrompt_upgradePromptButton__ikB7t:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%);
  transform: translateY(-1px);
}

.UpgradePrompt_upgradePromptSmall__0sWQN .UpgradePrompt_upgradePromptBody__H4c3i {
  padding: 1rem;
}
.UpgradePrompt_upgradePromptSmall__0sWQN .UpgradePrompt_upgradePromptIcon__PoijY {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}
.UpgradePrompt_upgradePromptSmall__0sWQN .UpgradePrompt_upgradePromptTitle__TUe\\+n {
  font-size: 1rem;
}
.UpgradePrompt_upgradePromptSmall__0sWQN .UpgradePrompt_upgradePromptDescription__2flIO {
  font-size: 0.8rem;
  margin-bottom: 1rem;
}
.UpgradePrompt_upgradePromptSmall__0sWQN .UpgradePrompt_upgradePromptButton__ikB7t {
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
}

.UpgradePrompt_upgradePromptLarge__QW0I0 .UpgradePrompt_upgradePromptBody__H4c3i {
  padding: 3rem;
}
.UpgradePrompt_upgradePromptLarge__QW0I0 .UpgradePrompt_upgradePromptIcon__PoijY {
  font-size: 4rem;
  margin-bottom: 1.5rem;
}
.UpgradePrompt_upgradePromptLarge__QW0I0 .UpgradePrompt_upgradePromptTitle__TUe\\+n {
  font-size: 1.5rem;
}
.UpgradePrompt_upgradePromptLarge__QW0I0 .UpgradePrompt_upgradePromptDescription__2flIO {
  font-size: 1rem;
  margin-bottom: 2rem;
}
.UpgradePrompt_upgradePromptLarge__QW0I0 .UpgradePrompt_upgradePromptButton__ikB7t {
  padding: 1rem 2rem;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/common/UpgradePrompt.module.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,6DAAA;EACA,kBAAA;EACA,cAAA;AACF;AACE;EACE,qBAAA;EACA,2BAAA;EACA,yBAAA;AACJ;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AAAF;;AAGA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;AAAF;;AAGA;EACE,cAAA;EACA,qBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,6DAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;AAAF;AAEE;EACE,6DAAA;EACA,2BAAA;AAAJ;;AAME;EACE,aAAA;AAHJ;AAME;EACE,eAAA;EACA,qBAAA;AAJJ;AAOE;EACE,eAAA;AALJ;AAQE;EACE,iBAAA;EACA,mBAAA;AANJ;AASE;EACE,oBAAA;EACA,iBAAA;AAPJ;;AAYE;EACE,aAAA;AATJ;AAYE;EACE,eAAA;EACA,qBAAA;AAVJ;AAaE;EACE,iBAAA;AAXJ;AAcE;EACE,eAAA;EACA,mBAAA;AAZJ;AAeE;EACE,kBAAA;EACA,eAAA;AAbJ","sourcesContent":[".upgradePrompt {\n  border: 2px dashed #e0e0e0;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  text-align: center;\n  margin: 20px 0;\n  \n  &:hover {\n    border-color: #007bff;\n    transform: translateY(-2px);\n    transition: all 0.3s ease;\n  }\n}\n\n.upgradePromptBody {\n  padding: 2rem;\n}\n\n.upgradePromptIcon {\n  font-size: 3rem;\n  color: #6c757d;\n  margin-bottom: 1rem;\n}\n\n.upgradePromptTitle {\n  color: #495057;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n\n.upgradePromptDescription {\n  color: #6c757d;\n  margin-bottom: 1.5rem;\n  font-size: 0.9rem;\n}\n\n.upgradePromptButton {\n  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);\n  border: none;\n  padding: 0.75rem 1.5rem;\n  font-weight: 600;\n  \n  &:hover {\n    background: linear-gradient(135deg, #0056b3 0%, #004085 100%);\n    transform: translateY(-1px);\n  }\n}\n\n// Size variants\n.upgradePromptSmall {\n  .upgradePromptBody {\n    padding: 1rem;\n  }\n  \n  .upgradePromptIcon {\n    font-size: 2rem;\n    margin-bottom: 0.5rem;\n  }\n  \n  .upgradePromptTitle {\n    font-size: 1rem;\n  }\n  \n  .upgradePromptDescription {\n    font-size: 0.8rem;\n    margin-bottom: 1rem;\n  }\n  \n  .upgradePromptButton {\n    padding: 0.5rem 1rem;\n    font-size: 0.8rem;\n  }\n}\n\n.upgradePromptLarge {\n  .upgradePromptBody {\n    padding: 3rem;\n  }\n  \n  .upgradePromptIcon {\n    font-size: 4rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  .upgradePromptTitle {\n    font-size: 1.5rem;\n  }\n  \n  .upgradePromptDescription {\n    font-size: 1rem;\n    margin-bottom: 2rem;\n  }\n  \n  .upgradePromptButton {\n    padding: 1rem 2rem;\n    font-size: 1rem;\n  }\n}\n\n.upgradePromptDefault {\n  // Default styles are already defined above\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"upgradePrompt": `UpgradePrompt_upgradePrompt__Bkalh`,
	"upgradePromptBody": `UpgradePrompt_upgradePromptBody__H4c3i`,
	"upgradePromptIcon": `UpgradePrompt_upgradePromptIcon__PoijY`,
	"upgradePromptTitle": `UpgradePrompt_upgradePromptTitle__TUe+n`,
	"upgradePromptDescription": `UpgradePrompt_upgradePromptDescription__2flIO`,
	"upgradePromptButton": `UpgradePrompt_upgradePromptButton__ikB7t`,
	"upgradePromptSmall": `UpgradePrompt_upgradePromptSmall__0sWQN`,
	"upgradePromptLarge": `UpgradePrompt_upgradePromptLarge__QW0I0`
};
export default ___CSS_LOADER_EXPORT___;
